import axios from "@/plugins/axios";

const DEFAULT_META_KEYS = [
  { selector: 'meta[name="keywords"]', attributes: { name: "keywords" }, attr: "content", key: "htmlKeywords" },
  { selector: 'meta[name="description"]', attributes: { name: "description" }, attr: "content", key: "htmlDescription" },
  { selector: 'meta[property="og:title"]', attributes: { property: "og:title" }, attr: "content", key: "htmlTitle" },
  {
    selector: 'meta[property="og:description"]',
    attributes: { property: "og:description" },
    attr: "content",
    key: "htmlDescription",
  },
  { selector: 'meta[property="og:image"]', attributes: { property: "og:image" }, attr: "content", key: "htmlPropertyImg" },
  { selector: 'meta[itemprop="name"]', attributes: { itemprop: "name" }, attr: "content", key: "htmlTitle" },
  {
    selector: 'meta[itemprop="description"]',
    attributes: { itemprop: "description" },
    attr: "content",
    key: "htmlDescription",
  },
  { selector: 'meta[itemprop="image"]', attributes: { itemprop: "image" }, attr: "content", key: "htmlItempropImg" },
];

function upsertHeadTag(selector, tagName, attributes, targetAttr, value) {
  if (!value) return;

  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement(tagName);
    Object.entries(attributes).forEach(([key, attrValue]) => {
      element.setAttribute(key, attrValue);
    });
    document.head.appendChild(element);
  }

  element.setAttribute(targetAttr, value);
}

/**
 * 파비콘을 고객사 아이콘으로 교체한다.
 * 기존 link 의 href 만 바꾸면 이미 렌더된 아이콘을 갱신하지 않는 브라우저가 있어,
 * 태그를 지우고 새로 넣는다. (meta 태그는 이 문제가 없어 upsertHeadTag 를 그대로 쓴다)
 */
function replaceFavicon(iconUrl) {
  if (!iconUrl) return;

  ["icon", "shortcut icon"].forEach((rel) => {
    document.head.querySelectorAll(`link[rel="${rel}"]`).forEach((element) => element.remove());

    const link = document.createElement("link");
    link.setAttribute("rel", rel);
    link.setAttribute("href", iconUrl);
    document.head.appendChild(link);
  });
}

function normalizeSeoData(data) {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return null;
  }

  return data;
}

function resolveSeoDomain() {
  const params = new URLSearchParams(location.search);
  const overrideDomain = params.get("domain");

  if (overrideDomain) {
    return overrideDomain.trim();
  }

  return location.hostname;
}

function resolveSeoParams() {
  const params = new URLSearchParams(location.search);
  // index.html 인라인 스크립트가 URL 에서 idxLeSiteMain 을 미리 제거하고 window.__LIFEEDU_IDX__ 에 보관하므로 폴백으로 읽는다.
  const idxLeSiteMain = params.get("idxLeSiteMain") || (typeof window !== "undefined" ? window.__LIFEEDU_IDX__ : null);
  const domain = resolveSeoDomain();

  return {
    domain,
    idxLeSiteMain: idxLeSiteMain?.trim() || null,
  };
}

export async function fetchSiteSeoByDomain(domain = resolveSeoDomain()) {
  const normalizedDomain = domain?.trim();
  const { idxLeSiteMain } = resolveSeoParams();

  if (!normalizedDomain && !idxLeSiteMain) {
    console.log("[SEO] skip fetch: no domain and no idxLeSiteMain");
    return null;
  }

  console.log("[SEO] fetch params", {
    domain: normalizedDomain,
    idxLeSiteMain,
    hostname: location.hostname,
    href: location.href,
  });

  const response = await axios.get("/user/page/siteMainSeo", {
    params: {
      domain: normalizedDomain,
      idxLeSiteMain,
    },
  });

  console.log("[SEO] fetch response", response?.data);

  if (response?.data?.success !== true) {
    return null;
  }

  return normalizeSeoData(response.data.data);
}

export function applySiteSeo(seoData) {
  const seo = normalizeSeoData(seoData);

  if (!seo) {
    return;
  }

  if (seo.htmlTitle) {
    document.title = seo.htmlTitle;
  }

  DEFAULT_META_KEYS.forEach(({ selector, attributes, attr, key }) => {
    const value = seo[key];
    if (!value) return;
    upsertHeadTag(selector, "meta", attributes, attr, value);
  });

  replaceFavicon(seo.htmlIconImg);
}

export async function initSiteSeo() {
  try {
    const seoData = await fetchSiteSeoByDomain();
    console.log("[SEO] normalized data", seoData);
    applySiteSeo(seoData);
    return seoData;
  } catch (error) {
    console.error("Failed to load site SEO", error);
    return null;
  }
}
